/* Upicko theme script: drawer, cart, product options, collection tools. No dependencies. */
(function(){
  var $=function(s,r){return (r||document).querySelector(s)};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var money=function(c){return '$'+(c/100).toFixed(2)};
  function toast(m){var t=$('#toast');if(!t)return;t.textContent=m;t.classList.add('on');clearTimeout(toast.t);toast.t=setTimeout(function(){t.classList.remove('on')},1800)}

  /* Departments drawer */
  document.addEventListener('click',function(e){
    var m=e.target.closest('[data-menu]');
    if(m){e.preventDefault();var d=$('#drawer');d.classList.add('open');var c=$('.close',d);if(c)c.focus();return}
    if(e.target.closest('[data-close]')){$('#drawer').classList.remove('open')}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){var d=$('#drawer');if(d)d.classList.remove('open')}});

  /* Estimated delivery: 1 business day processing + 8-11 business days transit */
  function bizAdd(d,n){d=new Date(d);while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w&&w!==6)n--}return d}
  function fmt(d){return d.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'})}
  $$('[data-eta]').forEach(function(el){var t=new Date();el.textContent=fmt(bizAdd(t,9))+' – '+fmt(bizAdd(t,12))});

  /* Add to cart without leaving the page (falls back to a normal form post) */
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f.matches('form[action$="/cart/add"]'))return;
    var sub=e.submitter;
    if(sub&&sub.name==='return_to')return;
    e.preventDefault();
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok){toast(res.j.description||'Could not add to cart');return}
        return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
          $$('.cart-ct').forEach(function(x){x.textContent=c.item_count});toast('Added to cart');if(/^\/cart\/?$/.test(location.pathname))setTimeout(function(){location.reload()},600)});
      }).catch(function(){f.submit()});
  });

  /* Quantity stepper */
  document.addEventListener('click',function(e){
    var q=e.target.closest('[data-q]');if(!q)return;
    var i=q.closest('.qty').querySelector('input');i.value=Math.max(1,(parseInt(i.value,10)||1)+parseInt(q.dataset.q,10));
  });

  /* Gallery thumbnails */
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-img]');if(!t)return;
    var m=$('#mainimg');m.srcset=t.dataset.srcset||'';m.src=t.dataset.img;
    $$('[data-img]').forEach(function(b){b.setAttribute('aria-current',b===t)});
  });

  /* Variant picker */
  var pj=$('#up-product-json');
  if(pj){
    var P=JSON.parse(pj.textContent);
    var cur=P.variants.filter(function(v){return v.id===P.selected})[0]||P.variants[0];
    var sel=cur.options.slice();
    var upd=function(){
      var v=P.variants.filter(function(v){return v.options.every(function(x,i){return x===sel[i]})})[0];
      var btns=$$('[data-addv]');
      if(!v){btns.forEach(function(b){b.disabled=true;b.textContent='Unavailable'});return}
      $$('input[name="id"]').forEach(function(i){i.value=v.id});
      $('#price').textContent=money(v.price);
      var sp=$('#sprice');if(sp)sp.textContent=money(v.price);
      $('#sku').textContent=v.sku||'';
      var st=$('#stock');st.className='stock '+(v.available?'in':'out');st.textContent=v.available?'In stock, ready to ship':'Out of stock';
      btns.forEach(function(b){b.disabled=!v.available;b.textContent=v.available?'Add to cart':'Out of stock'});
      var bn=$('[data-buynow]');if(bn)bn.disabled=!v.available;
      if(v.img){var m=$('#mainimg');m.srcset='';m.src=v.img}
      try{var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u)}catch(err){}
    };
    document.addEventListener('click',function(e){
      var o=e.target.closest('[data-opt]');if(!o)return;
      var i=parseInt(o.dataset.opt,10);sel[i]=o.dataset.val;
      $$('button',o.parentNode).forEach(function(b){b.setAttribute('aria-pressed',b===o)});
      var l=$('[data-optlbl="'+i+'"]');if(l)l.textContent=o.dataset.val;
      upd();
    });
  }

  /* Collection: product-type chips, sort, price buckets */
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-type]');if(!t)return;
    var v=t.dataset.type;
    $$('button',t.parentNode).forEach(function(b){b.setAttribute('aria-pressed',b===t)});
    $$('#cgrid .card').forEach(function(c){c.hidden=!!v&&c.dataset.type!==v});
  });
  document.addEventListener('change',function(e){
    if(e.target.matches('[data-sort]')){var u=new URL(location.href);u.searchParams.set('sort_by',e.target.value);u.searchParams.delete('page');location.href=u.toString()}
  });
  var qs=new URLSearchParams(location.search);
  $$('[data-pb]').forEach(function(a){
    var g=a.dataset.gte||'',l=a.dataset.lte||'';
    var on=(qs.get('filter.v.price.gte')||'')===g&&(qs.get('filter.v.price.lte')||'')===l&&(g||l);
    var u=new URL(location.href);u.searchParams.delete('page');
    if(on){u.searchParams.delete('filter.v.price.gte');u.searchParams.delete('filter.v.price.lte');a.classList.add('on')}
    else{if(g)u.searchParams.set('filter.v.price.gte',g);else u.searchParams.delete('filter.v.price.gte');if(l)u.searchParams.set('filter.v.price.lte',l);else u.searchParams.delete('filter.v.price.lte')}
    a.href=u.toString();
  });
})();
